import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import {
  quoteOuterContainer,
  quoteInnerContainer,
  quoteColumnContainer,
  quoteHeadingContainer,
  quoteColumn,
  quoteDark,
  quoteTextContainer,
  quoteImageContainer,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const Quote = ({
  subtitle,
  images,
  isDarkTheme,
  backgroundColor,
  quoteAuthor,
  quoteAuthorTitle,
  nodeLocale,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000000' : '#ffffff'
  const image = images ? images[0] : ''
  return (
    <div
      className={isDarkTheme ? quoteDark : ''}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', quoteOuterContainer].join(' ')}>
        <div className={['container', quoteInnerContainer].join(' ')}>
          <div className={quoteColumnContainer}>
            <div className={quoteColumn}>
              {image &&
                (isSvgOrGif(image.file.url) ? (
                  <div className={quoteImageContainer}>
                    <img src={image.file.url} alt={image.description} />
                  </div>
                ) : (
                  <div className={quoteImageContainer}>
                    <GatsbyImage
                      image={getImage(image.quote)}
                      alt={image.description}
                    />
                  </div>
                ))}
              <div className={quoteHeadingContainer}>
                {quoteAuthor && <h3>{quoteAuthor}</h3>}
                {quoteAuthorTitle && <h4>{quoteAuthorTitle}</h4>}
              </div>
            </div>
            <div className={quoteColumn}>
              {subtitle && (
                <p className={quoteTextContainer}>
                  {nodeLocale.indexOf('jp') !== -1
                    ? `${subtitle?.subtitle}`
                    : `“${subtitle?.subtitle}”`}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quote
